import { render } from "@wordpress/element";
import Collapsible from "./Collapsible";

(() => {
  const temp = document.createElement('div');
  temp.style.display = "none";
  document.querySelector("body").appendChild(temp);

  document.querySelectorAll(".collapsible-container").forEach((container) => {
    const content = container.querySelector(".collapsible-content");
    const props = JSON.parse(container.dataset.props);

    temp.appendChild(content)

    render(<Collapsible {...props} content={content} />, container);
  });

  temp.remove();
})();
